import AvailabilitySearch from './availability_search';

export default AvailabilitySearch;
